import type { CSSProperties, SVGProps } from 'react';

/** Иконка метро — `src/assets/metro.svg` */
export default function MetroIcon({
  color = '#E65A8C',
  size = 14,
  className,
  style,
  ...props
}: Omit<SVGProps<SVGSVGElement>, 'color'> & { color?: string; size?: number }) {
  const height = Math.round((size * 10) / 14);
  return (
    <svg
      {...props}
      className={className}
      width={size}
      height={height}
      viewBox="0 0 14 10"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={{ ...style, ['--metro-fill' as string]: color } as CSSProperties}
    >
      <path
        d="M9.75441 0L13.0328 8.60245L14 8.6052V9.89831H9.04351V8.6052H9.77423L9.06333 6.46832L6.99009 10L4.91685 6.46832L4.20595 8.6052H4.93667V9.89831H0V8.6052H0.947429L4.22577 0L6.99009 5.02954L9.75441 0Z"
        fill={color}
      />
    </svg>
  );
}
